import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Button, Spinner } from "react-bootstrap";
import FormComponent from "./common/formComponent";
import PageLoading from "./common/pageLoading";

import { getEquipmentById, updateEquipment } from "../services/equipmentService";

class Equipment extends FormComponent {
  state = {
    data: {
      _id: "",
      name: "",
      sn: "",
      oltSlot: "",
      oltPort: "",
      ontId: "",
      nasId: "",
      ponOLTId: "",
      internetServicePort: "",
      userId: "",
      allOLTs: [],
      provisioningStatus: "",
      billingCycleId: "",
      ipAcquisition: "",
      primaryIpV4Address: "",
    },
    errors: {},
    loading: true,
    processing: false,
  };

  schema = {
    _id: Joi.string().required(),
    name: Joi.string().required().label("Name"),
    sn: Joi.string().required().label("Serial Number"),
    oltSlot: Joi.number().required().label("OLT Slot"),
    oltPort: Joi.number().min(0).max(15).required().label("OLT Port"),
    ontId: Joi.number().min(0).max(127).required().label("ONT Id"),
    ponOLTId: Joi.string().required().label("OLT Id"),
    nasId: Joi.string().required().label("NAS"),
    internetServicePort: Joi.number().min(0).max(32767).required().label("Service Port"),
    userId: Joi.string().required().label("User Id"),
    allOLTs: Joi.array().required().label("All OLTs"),
    provisioningStatus: Joi.string().required().label("Provisioning Status"),
    premium: Joi.number().required().label("Premium"),
    premiumValueType: Joi.string().required().label("Premium Value Type"),
    billingCycleId: Joi.string().required().label("Billing Cycle Id"),
    ipAcquisition: Joi.string().required().label("IP Acquisition"),
    primaryIpV4Address: Joi.string().optional().label("Primary IP Address"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const updatedData = { ...this.state.data };
    delete updatedData.provisioningStatus;
    try {
      await updateEquipment(updatedData);
      toast.success("Equipment Information Updated");
      this.props.history.push(`/customers/${this.state.data.userId}/equipment`);
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    const { match } = this.props;
    const equipmentId = match.params.equipmentId;

    try {
      const { data } = await getEquipmentById(equipmentId);
      this.setState({ data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { data, errors, loading, processing } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && (
          <Form className="mt-4" onSubmit={this.handleSubmit}>
            {data.allOLTs && (
              <React.Fragment>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name="name" onChange={this.handleChange} value={data.name} size="sm" type="text" />
                  {errors.name && <span className="text-danger">{errors.name}</span>}
                </Form.Group>

                <Form.Group controlId="sn">
                  <Form.Label>S/N</Form.Label>
                  <Form.Control name="sn" onChange={this.handleChange} value={data.sn} size="sm" type="text" />
                  {errors.sn && <span className="text-danger">{errors.sn}</span>}
                </Form.Group>

                <Form.Group controlId="oltSlot">
                  <Form.Label>OLT Slot</Form.Label>
                  <Form.Control
                    name="oltSlot"
                    onChange={this.handleChange}
                    value={data.oltSlot}
                    size="sm"
                    type="text"
                  />
                  {errors.oltSlot && <span className="text-danger">{errors.oltSlot}</span>}
                </Form.Group>

                <Form.Group controlId="oltPort">
                  <Form.Label>OLT Port (0-15)</Form.Label>
                  <Form.Control
                    name="oltPort"
                    onChange={this.handleChange}
                    value={data.oltPort}
                    size="sm"
                    type="text"
                  />
                  {errors.oltPort && <span className="text-danger">{errors.oltPort}</span>}
                </Form.Group>

                <Form.Group controlId="ontId">
                  <Form.Label>ONT ID (0-127)</Form.Label>
                  <Form.Control name="ontId" onChange={this.handleChange} value={data.ontId} size="sm" type="text" />
                  {errors.ontId && <span className="text-danger">{errors.ontId}</span>}
                </Form.Group>

                <Form.Group controlId="internetServicePort">
                  <Form.Label>Internet Service Port (0-32767)</Form.Label>
                  <Form.Control
                    name="internetServicePort"
                    onChange={this.handleChange}
                    value={data.internetServicePort}
                    size="sm"
                    type="text"
                  />
                  {errors.internetServicePort && <span className="text-danger">{errors.internetServicePort}</span>}
                </Form.Group>

                <Form.Group>
                  <Button type="submit" disabled={this.validate() || processing}>
                    {processing && (
                      <Spinner
                        as="span"
                        className="mr-2"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Update
                  </Button>
                </Form.Group>
              </React.Fragment>
            )}
          </Form>
        )}
      </React.Fragment>
    );
  }
}

export default Equipment;
